import React from 'react'

import {
  LocationSearchButton,
  LocationSelection,
  CategoryList,
  TopProjectsContainer,
  Search
} from 'discover'

export class Overview extends React.Component {
  render() {
    return (
      <div>
        <div className='container container-location-search'>
          <div className='row'>
            <div className='col-md-12'>
              <LocationSelection
                buttonClass={ LocationSearchButton }
                boundsChanged={ this.props.boundsChanged }
                locations={ this.props.locations }
              />
            </div>
            <div className='col-md-12 search-column'>
              <div className='search-wrapper overview-search-wrapper'>
                <Search
                  searchQueryChanged={ this.props.searchQueryChanged }
                  searchQuery={ this.props.searchQuery }
                />
              </div>
              <SpendomatTeaser />
            </div>
          </div>
        </div>

        <div className='container container-teaser-list'>
          <CategoryList
            categoryChanged={ this.props.categoryChanged }
            categories={ this.props.categories }
          />
        </div>

        <div className='container container-top-projects'>
          <TopProjectsContainer
            apiBaseUrl={ this.props.apiBaseUrl }
          />
        </div>
      </div>
    )
  }
}

const SpendomatTeaser = () => {
  if (I18n.locale !== 'de') return null
  return <a className='m-t' style={{marginBottom: '-20px'}} href='https://www.betterplace.org/c/spenden-sammeln/spendomat'>
    <span className='nowrap'>Entdecke dein Herzensprojekt</span> <span className='nowrap'>mit dem Spend-O-Mat</span>
  </a>
}
